import { savedOrderDetailsCartLineStyles } from "@waytek/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.tooltip = {
    ...savedOrderDetailsCartLineStyles.tooltip,
    iconProps: {
        ...savedOrderDetailsCartLineStyles.tooltip?.iconProps,
        mergeCss: true,
        color: colorStrings.commonGlobalGuardianBlue,
    },
    cssOverrides: {
        tooltipWrapper: css`
            ${savedOrderDetailsCartLineStyles.tooltip?.cssOverrides?.tooltipWrapper}
            margin-right: 5px;
        `,
    },
};
